/** Minimum discount depth (as fraction) for a vendor-day to be on promotion; CONTEXT.md On-promotion owns the definition, ruling 2026-10-16. */
export const PROMO_THRESHOLD = 0.1;

/** Floating-point slack on a depth comparison: (119 - 107.1) / 119 is 0.10000000000000005 in binary floating point, and one öre on a 10 000 kr price is 1e-6. */
export const DEPTH_EPSILON = 1e-9;

/** True when a depth already computed as a fraction strictly exceeds PROMO_THRESHOLD, exactly 10 percent excluded. */
export function isPromoDepth(depth: number | null | undefined): boolean {
  return depth != null && depth > PROMO_THRESHOLD + DEPTH_EPSILON;
}

/** Depth of price under regularPrice as a fraction; null unless both are positive, zero or negative when price is at or above it. */
export function discountDepth(
  price: number | null | undefined,
  regularPrice: number | null | undefined
): number | null {
  if (price == null || regularPrice == null || price <= 0 || regularPrice <= 0) return null;
  return (regularPrice - price) / regularPrice;
}

/** discountDepth in percent (0-100). */
export function discountDepthPercent(
  price: number | null | undefined,
  regularPrice: number | null | undefined
): number | null {
  const depth = discountDepth(price, regularPrice);
  return depth === null ? null : depth * 100;
}

/** True when the depth strictly exceeds PROMO_THRESHOLD (CONTEXT.md, On-promotion). */
export function isOnPromotion(
  price: number | null | undefined,
  regularPrice: number | null | undefined
): boolean {
  return isPromoDepth(discountDepth(price, regularPrice));
}
